import { CompanyDto } from './company-dto.model';


export class DesignationDto implements IDesignationDto {
    id!: number;
    company!: CompanyDto;
    designationName!: string | undefined;
    isClarify!: boolean;
    isJobSeeker!: boolean;
    canApprove!: boolean;
    extraDay!: number;
    isActive!: boolean;
    isDirector!: boolean;
    isHR!: boolean;

    constructor(data?: IDesignationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.company = _data["company"] ? CompanyDto.fromJS(_data["company"]) : <any>undefined;
            this.designationName = _data["designationName"];
            this.isClarify = _data["isClarify"];
            this.isJobSeeker = _data["isJobSeeker"];
            this.canApprove = _data["canApprove"];
            this.extraDay = _data["extraDay"];
            this.isActive = _data["isActive"];
            this.isDirector = _data["isDirector"];
            this.isHR = _data["isHR"];
        }
    }

    static fromJS(data: any): DesignationDto {
        data = typeof data === 'object' ? data : {};
        let result = new DesignationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["designationName"] = this.designationName;
        data["isClarify"] = this.isClarify;
        data["isJobSeeker"] = this.isJobSeeker;
        data["canApprove"] = this.canApprove;
        data["extraDay"] = this.extraDay;
        data["isActive"] = this.isActive;
        data["isDirector"] = this.isDirector;
        data["isHR"] = this.isHR;
        return data; 
    }
}

export interface IDesignationDto {
    id: number;
    company: CompanyDto;
    designationName: string | undefined;
    isClarify: boolean;
    isJobSeeker: boolean;
    canApprove: boolean;
    extraDay: number;
    isActive: boolean;
    isDirector: boolean;
    isHR: boolean;
}

